export type ThemeMode = "light" | "dark" | "system";
export type ResolvedTheme = "light" | "dark";

export const THEME_STORAGE_KEY = "cfmoto-theme";
export const THEME_UPDATED_EVENT = "cfmoto:theme-updated";

export const themeScript = `
(function() {
  try {
    var storageKey = '${THEME_STORAGE_KEY}';
    var theme = localStorage.getItem(storageKey);
    if (theme !== 'light' && theme !== 'dark' && theme !== 'system') {
      theme = 'system';
    }
    var resolved = theme === 'system'
      ? (window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light')
      : theme;
    document.documentElement.classList.toggle('dark', resolved === 'dark');
    document.documentElement.dataset.theme = resolved;
  } catch (error) {
    document.documentElement.dataset.theme = 'light';
  }
})();
`;
